import React from "react";
import PropTypes from "prop-types";

const ValueCard = ({ name, description, icon: Icon }) => {
	return (
		<div className="group h-full p-8 bg-white dark:bg-slate-800 rounded-2xl border border-slate-100 dark:border-slate-700 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
			<div className="mb-6 inline-block p-4 rounded-xl bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
				{Icon && <Icon size={32} strokeWidth={1.5} />}
			</div>
			
			<h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3 font-serif">
				{name}
			</h3>
			<p className="text-slate-600 dark:text-slate-400 leading-relaxed">
				{description}
			</p>
		</div>
	);
};

ValueCard.propTypes = {
	name: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	icon: PropTypes.elementType,
};

export default ValueCard;
